import React, { CSSProperties, Component } from 'react';
import { ObjectType } from '../types/object.type';
import Text from './text.component';
import Image from './image.component';
import '../styles/marker.css';
import { AppContext } from '../context';

class Marker extends Component<{className: string, id: string, text: string, lat: number, lng: number, zoom: number, onClick: (
  e: React.MouseEvent<HTMLDivElement, MouseEvent>,
  props: { id: string; lat: number; lng: number; },
) => void, object?: ObjectType, selected: boolean, zIndex: number, bubbleStyles?: CSSProperties}> {
  static contextType = AppContext;
  context!: React.ContextType<typeof AppContext>;

  render ()  {
    const { state, dispatch } = this.context;
    const width = (this.props.zoom) + 25 + (this.props.selected ? 10 : 0);
    const height = (1.39 * width);
    const firstImage = (this.props.object?.images !== undefined ? this.props.object?.images[0] : false);

    return <div className={'marker ' + this.props.className} style={{
      top: '-' + height +'px',
      left: '-' + (width/2) + 'px',
      height: height,
      width: width
    }}
    onMouseEnter={(e) => {
      dispatch({
        type: 'setHighlight',
        payload: {
          highlight: (this.props.object ? this.props.object.nid : false)
        }
      });
    }}
    onMouseLeave={(e) => {
      dispatch({
        type: 'setHighlight',
        payload: {
          highlight: false
        }
      });
    }}
    onClick={(e) => this.props.onClick(e, {
        id: this.props.id,
        lat: this.props.lat,
        lng: this.props.lng
      })
    }>
      <div style={{ width: '100%' }}>
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
          viewBox="0 0 55 73">
          <path className="st0" style={{
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: (this.props.selected || (state.highlight && this.props.object?.nid === state.highlight) ? "#202020" : "#AFA682")
          }} d="M40.1,27.3c0,7.1-5.9,12.6-12.6,12.6c-7.2,0-12.5-5.9-12.5-12.6c0-7.2,5.7-12.4,12.5-12.4
            C34.6,14.9,40.1,20.6,40.1,27.3z M55,27.3c0,3-0.7,6.3-1.7,9.4c-0.7,2.4-2.3,5.7-3.6,8.3c-1.9,3.6-4.4,7.7-7.2,11.3
            c-1.6,2.1-3.4,4.4-5.3,6.7c-0.7,0.9-8.3,10-9.8,10c-1,0-3.6-3.3-3.9-3.4c-6.6-7.1-12.1-14.1-16.4-21C4.6,44.4,0,34.3,0,29.1v-3.6
            C1.7,8.7,14.9,0,27.4,0C43.1,0,55,12.6,55,27.3z"/>
          <circle className="st1" cx="27.2" cy="27.4" r="21" style={{
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "#FFFFFF"
          }}/>
            {this.props.text !== '' &&
              <text x="50%" y="50%" textAnchor='middle' style={{
                fontSize: '21px',
                fontWeight: '600',
                fill: "#AFA682"
              }}>{this.props.text}</text>}
            {this.props.text === '' &&
              <g
                id="g30"
                transform="matrix(0.16794626,0,0,0.16794626,-9.7481769,2.8462571)">
                {this.props.selected &&
                  <path
                      d="m 220,44.498 c 56.025,0 101.702,45.32 101.702,101.702 0,56.382 -45.677,101.345 -101.702,101.345 -56.025,0 -101.702,-45.32 -101.702,-101.345 0,-56.025 45.32,-101.702 101.702,-101.702 M 220,42 c -57.453,0 -104.2,46.747 -104.2,104.2 0,57.453 46.747,104.2 104.2,104.2 57.453,0 104.2,-46.747 104.2,-104.2 C 324.2,88.747 277.096,42 220,42 Z"
                      style={{
                        clipRule: "evenodd",
                        fill: "#afa682",
                        fillRule: "evenodd"
                      }} />
                  }
                <path
                    d="m 173.61,105.162 c -0.714,0 -0.714,-0.357 -0.714,-0.713 0,-0.714 0.357,-2.498 1.784,-2.498 5.353,0 10.349,0.357 15.701,0.357 4.64,0 9.279,-0.357 13.918,-0.357 0.713,0 1.07,0 1.07,0.713 0,2.498 -0.714,2.855 -3.568,2.855 -6.424,0.714 -7.137,1.784 -9.992,15.702 -1.07,5.71 -11.062,54.954 -11.062,60.664 0,4.639 4.282,4.639 9.634,4.639 22.482,0 27.121,-5.353 29.262,-12.133 0.714,-2.141 0.714,-2.498 1.428,-2.498 0.714,0 2.14,0 2.14,1.07 0,0.358 -1.784,7.495 -2.854,10.706 -2.141,6.067 -2.855,7.137 -9.635,7.137 -8.921,0 -17.843,-0.357 -26.764,-0.357 -11.776,0 -18.913,0.357 -23.909,0.357 -0.357,0 -0.713,0 -0.713,-0.714 0,-2.497 1.07,-2.497 3.568,-2.854 6.423,-0.714 7.137,-1.785 9.992,-15.702 1.07,-5.352 11.062,-54.24 11.062,-59.95 -0.713,-5.353 -3.925,-5.71 -10.348,-6.424 z"
                    style={{
                      clipRule: "evenodd",
                      fill: "#afa682",
                      fillRule: "evenodd"
                    }} />
                <path
                    d="m 207.51,119.793 c 0,-14.274 10.706,-18.556 21.768,-18.556 1.427,0 6.067,0 10.706,0.357 4.639,0 8.564,0.357 10.705,0.357 4.64,0 9.635,-0.357 14.274,-0.357 1.427,0 1.784,1.784 1.784,2.498 0,0.357 0,0.357 -0.713,0.713 -6.067,0.714 -9.635,1.071 -9.635,6.78 0,5.353 9.991,54.599 11.062,59.951 2.855,13.917 3.568,14.988 9.992,15.702 2.855,0.357 3.568,0.357 3.568,2.854 0,0.714 -0.357,0.714 -0.713,0.714 -5.353,0 -10.35,-0.357 -15.702,-0.357 -5.71,0 -11.776,0.357 -17.485,0.357 -1.428,0 -1.785,-1.784 -1.785,-2.498 0,-0.713 0.357,-0.713 3.212,-0.713 6.066,-0.357 10.705,-0.357 10.705,-6.424 0,-6.067 -12.846,-69.229 -13.203,-70.656 -0.714,-2.498 -1.427,-4.639 -10.349,-4.639 -11.419,0 -17.842,4.64 -17.842,15.701 0,10.349 6.423,21.768 24.266,21.768 3.925,0 3.925,0 3.925,1.07 0,2.856 -1.07,2.856 -4.282,2.856 -18.556,-0.357 -34.258,-10.706 -34.258,-27.478 z"
                    style={{
                      clipRule: "evenodd",
                      fill: "#afa682",
                      fillRule: "evenodd"
                    }} />
              </g>}
        </svg>
      </div>

      {this.props.selected &&
        <div className='information-bubble' style={this.props.bubbleStyles}>
          <button className='close-btn'></button>
          {firstImage ?
            <Image
              src={firstImage}
              alt=''
              width={290}
              height={165}></Image>
            :<></>}
          <div className='main'>
            <div className='price' dangerouslySetInnerHTML={{ __html: (this.props.object?.price ? this.props.object.price : '') }}/>
            <div className='title'>{this.props.object?.title}</div>
          </div>
          <div className='info-table'>
            <div className='bedrooms'>
              <span className='value'>{this.props.object?.bedrooms ? this.props.object?.bedrooms : 'N/A'}</span>
              <span className='text'><Text text={'Bedrooms'}/></span>
            </div>
            <div className='bathrooms'>
              <span className='value'>{this.props.object?.bathrooms ? this.props.object?.bathrooms : 'N/A'}</span>
              <span className='text'><Text text={'Bathrooms'}/></span>
            </div>
            <div className='surface'>
              <span className='value'>{this.props.object?.surface ? this.props.object?.surface : 'N/A'}</span>
              <span className='text'><Text text={'SQM'}/></span>
            </div>
            <div className='postcode'>
              <span className='value'>{this.props.object?.field_object_canton_postcode ? this.props.object?.field_object_canton_postcode : 'N/A'}</span>
              <span className='text'>{this.props.object?.field_object_canton_canton ? this.props.object?.field_object_canton_canton : ''}</span>
            </div>
          </div>
          <div className='details'>
            <a href={this.props.object?.url} target='_blank' rel="noreferrer">
              <Text text={'Details'}/>
            </a>
          </div>
        </div>
      }
    </div>
  };
}
export default Marker;
